<template>
	<v-dialog
		v-model="dialog" width="500">
		<v-card>
			<v-card-title
				class="headline primary"
				primary-title>
				Nie można zapisać zmian
			</v-card-title>

			<v-card-text>
				Strona z wynikami konkursu nie może być pusta.
			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					class="button-close"
					color="blue"
					@click="closeDialog">
					OK
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: "EmptyResultPageDialogView",

		methods: {
			closeDialog () {
				this.$emit("update:showDialog", false);
			}
		},

		watch: {
			dialog (value) {
				if (!value) this.$emit("update:showDialog", false);
			},

			showDialog (value) {
				this.dialog = value;
			},
		},

		data () {
			return {
				dialog: false
			};
		},

		props: {
			showDialog: {
				type: Boolean,
				default: false
			}
		}
	};
</script>

<style scoped>

</style>